import Glide from "@glidejs/glide";
import $ from "jquery";

$(() => {
  const carousels = $(".image-carousel");
  if (carousels.length) {
    carousels.each((i, carouselEl) => {
      const carousel = $(carouselEl);
      const glide = new Glide(carousel.find(".glide")[0], {
        perView: 1,
        bound: true,
        gap: 108,
        breakpoints: {
          1024: {
            gap: 0
          }
        }
      });
      glide.mount();
      //   glide.on(["resize", "build.after"], () => {
      //     if ($(window).width() < 768) {
      //       const marginRight =
      //         parseInt($(".content-carousel .outer").css("marginRight")) || 24;

      //       $(".glide__slide").css("margin-right", marginRight);
      //     }
      //   });
      glide.on("move.after", () => {
        const index = glide.index + 1;
        carousel.find(".carousel-index").text(index);
      });
    });
  }
});
